var _style, _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.prefix__st1,\n\t\t.prefix__st2 {\n\t\t\tfill: none;\n\t\t\tstroke: #414141;\n\t\t\tstroke-miterlimit: 10\n\t\t}\n\n\t\t.prefix__st2 {\n\t\t\tstroke-width: .66\n\t\t}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1 1C21.7 1 23 2.3 23 3.9v16.2c0 1.6-1.3 2.9-2.9 2.9H3.9C2.3 23 1 21.7 1 20.1V3.9C1 2.3 2.3 1 3.9 1h16.2m0-1H3.9C1.7 0 0 1.7 0 3.9v16.2C0 22.3 1.7 24 3.9 24h16.2c2.2 0 3.9-1.7 3.9-3.9V3.9C24 1.7 22.3 0 20.1 0z",
    fill: "#414141"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "prefix__st1",
    cx: 12,
    cy: 12,
    r: 7.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "prefix__st1",
    cx: 12,
    cy: 12,
    r: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "prefix__st2",
    d: "M12 4.8V7M8.4 5.8l1.1 1.9M5.8 8.4l1.9 1.1M4.8 12H7M5.8 15.6l1.9-1.1M8.4 18.2l1.1-1.9M12 19.2V17M15.6 18.2l-1.1-1.9M18.2 15.6l-1.9-1.1M19.2 12H17M18.2 8.4l-1.9 1.1M15.6 5.8l-1.1 1.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.a45aa40c2ed90baff3738e55f3d81658.svg";
export { ForwardRef as ReactComponent };